import React, { useEffect, useRef } from "react";
import { BottomMenuButton } from "../../../bottom-menu/bottom-menu-button";
import {
	BottomMenuButtons,
	IBottomMenuButton,
	IBottomMenuButtonsRef,
} from "../../../bottom-menu/buttons";

export const SymbolsRootMenu = <T extends string = string>({
	showBackButton,
	onBack,
	menuItems,
}: {
	showBackButton: boolean;
	onBack: () => void;
	/** As argument so they can be prefetched */
	menuItems: readonly IBottomMenuButton<T>[];
}) => {
	const elRef = useRef<IBottomMenuButtonsRef>(null);

	// Scroll the new activeButton into view
	useEffect(() => {
		const activeButtonId = menuItems.find((item) => item.isActive)?.id;
		if (!elRef.current) return;
		const index = menuItems.findIndex((item) => item.id === activeButtonId);
		if (index < 0) return;
		elRef.current.scrollIntoView(index);
	}, [menuItems]);

	return (
		<BottomMenuButtons ref={elRef} fadeEnd showBackButton={showBackButton} onBack={onBack}>
			{menuItems.map((props) => {
				return <BottomMenuButton {...props} key={props.id} />;
			})}
		</BottomMenuButtons>
	);
};
SymbolsRootMenu.displayName = "SymbolsRootMenu";
